module.exports = __webpack_public_path__ + "img/Orden de papas.43fa5b99.jpeg";